import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadQATasksForServicing, markQATaskComplete, markQATaskUnable } from '../../actions/qa-tasks'

import QATaskList from '../../components/qa-tasks/qa-task-list'

function mapStateToProps (state, ownProps) {
  const id = ownProps.qaServicingId

  const qaServicing = state.qaServicings[id]
  const pagination = get(state, `pagination.qaTasksByQaServicing.${id}`, {})
  const qaTasks = at(state.qaTasks, pagination.ids || [])

  return {
    qaServicing,
    qaTasks,

    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadQATasksForServicing(ownProps.qaServicingId))

  return {
    onTaskComplete (id) {
      dispatch(markQATaskComplete(id))
    },

    onTaskUnable (id) {
      dispatch(markQATaskUnable(id))
    },

    onLoadNextPage () {
      dispatch(loadQATasksForServicing(ownProps.qaServicingId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QATaskList)



// WEBPACK FOOTER //
// ./src/containers/qa-tasks/qa-task-list-container.js